import { PlannerBase }   from "../planner_base";
import watch from "redux-watch";
import isEqual from 'is-equal';
class Warnings extends PlannerBase {
}
riot.mixin('orders.planner.warnings', Warnings as riot.TagMixin)
